import {APP_CONFIGURATIONS} from '../../../clients/app/config';
import {AnalyticsEventDataI, AnalyticsEventTypeI, AnalyticsProviderInterface} from './analytics.provider.i';
import {GoogleAnalyticsProvider, GtmAnalyticsProvider, MixpanelAnalyticsProvider} from './providers';


export class AnalyticsUtils {

    private static providers: AnalyticsProviderInterface[] = [];

    public static init(): void {
        if (APP_CONFIGURATIONS.analytic.mixpanel.enabled) {
            this.providers.push(new MixpanelAnalyticsProvider(APP_CONFIGURATIONS.analytic.mixpanel.token));
        }

        if (APP_CONFIGURATIONS.analytic.ga.enabled) {
            this.providers.push(new GoogleAnalyticsProvider(APP_CONFIGURATIONS.analytic.ga.token))
        }

        if (APP_CONFIGURATIONS.analytic.gtm.enabled) {
            this.providers.push(new GtmAnalyticsProvider(APP_CONFIGURATIONS.analytic.gtm.token))
        }
    }

    public static trackEvent<T extends keyof AnalyticsEventTypeI>(event_type: T, event_data: string | number | AnalyticsEventDataI, cb?: () => void): void {
        this.delegateToProviders(provider => provider.trackEvent(event_type, event_data));
    }

    private static delegateToProviders(callback: (provider: AnalyticsProviderInterface) => void) {
        this.providers.forEach(callback);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/analytics/analytics.utils.ts